<span *ngFor="let item of content" [class.marked]="item?.marked">{{ item.substr }}</span>
